import React, { Component } from 'react'
import { Sidebar, Icon } from '@driftt/tide'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getCategories, getCategory, getSectionToEdit, getSectionToDelete } from 'modules/knowledgebase/selectors'
import * as actions from 'modules/knowledgebase/actions'

import NavList from 'components/CategoryNav/NavList'
import EditCategoryContent from 'components/SidebarContent/EditCategoryContent'
import EditSectionContent from 'components/SidebarContent/EditSectionSidebarContent'
import DeleteCategoryModalContent from 'components/DeleteModalContent/DeleteCategoryModalContent'
import DeleteSectionModalContent from 'components/DeleteModalContent/DeleteSectionModalContent'

import './style.css'

const SECTION = 'section'
const CATEGORY = 'category'
const DROPPABLE_TYPE = 'CATEGORY_NAV'

class CategoryNav extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isSidebarOpen: false,
      isDeleteModalOpen: false,
      isCategoryOpen: props.isSelected
    }
  }
  
  handleCloseSidebar = () => {
    const { actions } = this.props
    this.setState({isSidebarOpen: false})
    
    actions.clearSectionToEdit()
    actions.clearCategory()
  }
  
  handleOpenSidebar = (item, type) => {
    const { actions } = this.props
    
    if (type === CATEGORY) {
      actions.setCategory(item)
    }
    
    if (type === SECTION) {
      actions.setSectionToEdit(item)
    }
    
    this.setState({isSidebarOpen: true})
  }
  
  handleOpenModal = (item, type) => {
    const { actions } = this.props
    
    if (type === CATEGORY) {
      actions.setCategory(item)
    }
    
    if (type === SECTION) {
      actions.setSectionToDelete(item)
    }
    
    this.setState({isDeleteModalOpen: true})
  }
  
  handleCloseModal = () => {
    const { actions } = this.props
    this.setState({isDeleteModalOpen: false})
    actions.clearCategory()
  }
  
  handleDragEnd = dropResult => {
    const { actions, categories} = this.props
    
    if (!!dropResult.destination) {
      const event = {
        sourceId: dropResult.draggableId,
        destinationId: categories[dropResult.destination.index].id,
        oldIndex: dropResult.source.index,
        newIndex: dropResult.destination.index
      }
      
      actions.reorderCategories(event)
    }
  }
  
  handleCategoryItemClick = () =>
    this.setState(prevState => ({
      isCategoryOpen: !prevState.isCategoryOpen
    }))
  
  handleSectionItemClick = e => e.stopPropagation()
  
  render() {
    const { categories, match, selectedSection, selectedCategory, sectionToDelete } = this.props
    const { isSidebarOpen, isDeleteModalOpen, isCategoryOpen } = this.state
    const parsedCategoryId = parseInt(match.params.categoryId, 10)
    const parsedSectionId = parseInt(match.params.sectionId, 10)
  
    return (
      <DragDropContext
        onDragEnd={this.handleDragEnd}
      >
        <Droppable
          droppableId="droppable-1"
          type={DROPPABLE_TYPE}
        >
          {(provided) => {
            return (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                className="category-nav-wrapper"
              >
                <span className="category-nav-title">
                  <Icon className="categories-nav-title-icon" name="categories-1" />
                  CATEGORIES
                </span>
                <div className="category-nav">
                  <NavList
                    isCategoryOpen={isCategoryOpen}
                    onCategoryItemClick={this.handleCategoryItemClick}
                    onSectionItemClick={this.handleSectionItemClick}
                    onOpenSidebar={this.handleOpenSidebar}
                    onOpenDeleteModal={this.handleOpenModal}
                    categories={categories}
                    parsedCategoryId={parsedCategoryId}
                    parsedSectionId={parsedSectionId}
                  />
                </div>
              
                <Sidebar
                  className="category-section-sidebar"
                  isOpen={isSidebarOpen}
                  showClose
                  close={this.handleCloseSidebar}
                >
                  {selectedSection.categoryId && <EditSectionContent onCloseSidebar={this.handleCloseSidebar}/>}
                  {selectedCategory.id && <EditCategoryContent onCloseSidebar={this.handleCloseSidebar}/>}
                </Sidebar>
              
                {selectedCategory.name &&
                  isDeleteModalOpen && <DeleteCategoryModalContent onCloseModal={this.handleCloseModal}/>
                }
                {sectionToDelete.name && isDeleteModalOpen &&
                  <DeleteSectionModalContent onCloseModal={this.handleCloseModal}/>
                }
                {provided.placeholder}
              </div>
            )
          }}
        </Droppable>
      </DragDropContext>
    )
  }
}

const mapStateToProps = state => ({
  categories: getCategories(state),
  selectedCategory: getCategory(state),
  selectedSection: getSectionToEdit(state),
  sectionToDelete: getSectionToDelete(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setCategory: actions.setCategory,
    clearCategory: actions.clearCategory,
    setSectionToEdit: actions.setSectionToEdit,
    clearSectionToEdit: actions.clearSectionToEdit,
    setSectionToDelete: actions.setSectionToDelete,
    clearSectionToDelete: actions.clearSectionToDelete,
    reorderCategories: actions.reorderCategories
  }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(CategoryNav)